/*
 * Removes HTML tags from a string
 */
export const removeHTML = (content: string) => content.replace(/<\/?[\w- =']+>/g, '');
